import {PRODUCTION} from "@irati/utils/constants/environment"
import env from "@irati/utils/env"

export default (APP_ID) => {
  /* eslint-disable */
  ;(function () {
    var w = window
    var ic = w.Intercom
    if (typeof ic === "function") {
      ic("update", w.intercomSettings)
    } else {
      var d = document
      var i = function () {
        i.c(arguments)
      }
      i.q = []
      i.c = function (args) {
        i.q.push(args)
      }
      w.Intercom = i
      var l = function () {
        var s = d.createElement("script")
        s.type = "text/javascript"
        s.async = true
        s.src = "https://widget.intercom.io/widget/" + APP_ID
        var x = d.getElementsByTagName("script")[0]
        x.parentNode.insertBefore(s, x)
      }
      if (document.readyState === "complete") {
        l()
      } else if (w.attachEvent) {
        w.attachEvent("onload", l)
      } else {
        w.addEventListener("load", l, false)
      }
    }
  })()
  /* eslint-enable */
}

export const getIntercomKey = () => {
  if (env.ENVIRONMENT_NAME === PRODUCTION) {
    return "effyqzrr" // New prod instance: z3rmv6xv
  }
  // Testing new instance on staging
  return "vbcvngdn" // Old test instance: s2maiwk8
}

export const getIntercomBaseUrl = () => {
  if (env.ENVIRONMENT_NAME === PRODUCTION) {
    return "https://api-iam.intercom.io"
  }
  // Testing EU region on staging
  return "https://api-iam.eu.intercom.io"
}
